import React, { useState } from "react";

const pujaVideos = [
  { src: "https://www.youtube.com/embed/5TuN4ik-LXE", title: "Rudra Abhishek Puja" },
  { src: "https://www.youtube.com/embed/nln2_mvJwvo", title: "Mangal Dosh Puja" },
  { src: "https://www.youtube.com/embed/x5IjF_ec_YM", title: "Durga Path Puja" },
  { src: "https://www.youtube.com/embed/WivlcJdWrdc", title: "Shani Shanti Puja" },
];

const PujaVideos = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  return (
    <div className="py-10 bg-yellow-50">
      <h2 className="text-4xl font-bold text-center text-yellow-800 mb-6">
        Puja Video Gallery
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 px-4 sm:px-28">
        {pujaVideos.map((video, index) => (
          <div 
            key={index} 
            className="relative group overflow-hidden rounded-lg shadow-lg cursor-pointer"
            onClick={() => setSelectedVideo(video.src)}
          >
            {/* Thumbnail */}
            <img 
              src={`https://img.youtube.com/vi/${video.src.split("/embed/")[1]}/hqdefault.jpg`} 
              alt={video.title} 
              className="w-full h-60 md:h-80 rounded-lg transition-transform duration-300 group-hover:scale-105"
            />
            
            {/* Video Title - Appears on Hover */}
            <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-70 text-white text-center text-lg font-semibold py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              {video.title}
            </div>
          </div>
        ))}
      </div>

      {/* Video Popup Modal */}
      {selectedVideo && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
          <div className="relative w-full max-w-4xl">
            <button 
              className="absolute top-2 right-4 text-white text-2xl font-bold"
              onClick={() => setSelectedVideo(null)}
            >
              ✖
            </button>
            <iframe
              src={`${selectedVideo}?autoplay=1&mute=0`}
              title="Puja Video"
              className="w-full h-96 rounded-lg"
              allow="autoplay; encrypted-media"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default PujaVideos;
